export const fileTypeFromMime = (mime: string): string => {
  const value = String(mime || "").toLowerCase();
  if (value === "image/jpeg" || value === "image/jpg") {
    return "image/jpeg";
  }
  if (value === "image/png") {
    return "image/png";
  }
  if (value === "image/heic") {
    return "image/heic";
  }
  if (value === "image/heif") {
    return "image/heif";
  }
  if (value === "image/bmp") {
    return "image/bmp";
  }
  if (value === "video/mp4") {
    return "video/mp4";
  }
  if (value === "video/quicktime") {
    return "video/quicktime";
  }
  if (value === "video/x-m4v") {
    return "video/x-m4v";
  }
  if (value === "video/webm") {
    return "video/webm";
  }
  if (value === "application/pdf") {
    return "application/pdf";
  }
  return "image/jpeg";
};

export const newMediaId = (): string => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `m-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};
